import styles from "./EditPost.module.css";

import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthValue } from "../../context/AuthContext";
import { useFetchDocument } from "../../hooks/useFetchDocument";
import { useUpdateDocument } from "../../hooks/useUpdateDocument";

const EditPost = () => {
    const { id } = useParams();
    const { document: post } = useFetchDocument("posts", id);

    console.log(post);

    const [title, setTitle] = useState("");
    const [image, setImage] = useState("");
    const [body, setBody] = useState("");
    const [tags, setTags] = useState([]);
    const [formError, setFormError] = useState("");

    // fill form data
    useEffect(() => {
        if (post) {
            setTitle(post.title);
            setImage(post.image);
            setBody(post.body);

            const textTags = post.tags.join(", ");

            setTags(textTags);
        }
    }, [post]);

    const { user } = useAuthValue();

    const navigate = useNavigate();

    const { updateDocument, response } = useUpdateDocument("posts");

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormError("");

        // validate image
        try {
            new URL(image);
        } catch (error) {
            setFormError("A imagem precisa ser uma URL.");
        }

        // create tags array
        const tagsArray = tags.split(",").map((tag) => tag.trim());

        console.log(tagsArray);

        console.log({
            title,
            image,
            body,
            tags: tagsArray,
        });

        const data = {
            title,
            image,
            body,
            tags: tagsArray,
        };

        console.log(post);

        updateDocument(id, data);

        // redirect to home page
        navigate("/dashboard");
    };

    return (
        <div className={styles.edit_post}>
            {post && (
                <>
                    <div className={styles.title}>
                        <h2>Editando post: {post.title}</h2>
                        <p>Altere os dados do post como desejar</p>
                    </div>
                    <div className={styles.edit_form}>
                        <form onSubmit={handleSubmit}>
                            <label>
                                <span>Título:</span>
                                <input
                                    type="text"
                                    name="text"
                                    required
                                    placeholder="Pense num bom título..."
                                    onChange={(e) => setTitle(e.target.value)}
                                    value={title}
                                />
                            </label>
                            <label>
                                <span>URL da imagem:</span>
                                <input
                                    type="text"
                                    name="image"
                                    required
                                    placeholder="Insira uma imagem que representa seu post"
                                    onChange={(e) => setImage(e.target.value)}
                                    value={image}
                                />
                            </label>
                            <p className={styles.preview_title}>
                                Preview da imagem atual:
                            </p>
                            <img
                                className={styles.image_preview}
                                src={post.image}
                                alt={post.title}
                            />
                            <label>
                                <span>Conteúdo:</span>
                                <textarea
                                    name="body"
                                    required
                                    placeholder="Insira o conteúdo do post"
                                    onChange={(e) => setBody(e.target.value)}
                                    value={body}
                                ></textarea>
                            </label>
                            <label>
                                <span>Tags:</span>
                                <input
                                    type="text"
                                    name="tags"
                                    required
                                    placeholder="Insira as tags separadas por vírgula"
                                    onChange={(e) => setTags(e.target.value)}
                                    value={tags}
                                />
                            </label>
                            {!response.loading && (
                                <button className="btn">Editar</button>
                            )}
                            {response.loading && (
                                <button className="btn" disabled>
                                    Aguarde.. .
                                </button>
                            )}
                            {(response.error || formError) && (
                                <p className="error">
                                    {response.error || formError}
                                </p>
                            )}
                        </form>
                    </div>
                </>
            )}
        </div>
    );
};

export default EditPost;
